import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent {

    private componentRoute = '/administration';
    public history: Array<string> = [];
    public title: string;

    constructor(
        public router: Router,
        private _auth: AuthService,
        private _login: LoginService
    ) {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                if ((val as NavigationEnd).url && (val as NavigationEnd).url !== '') {
                    this.addRouteToHistory((val as NavigationEnd).url);
                }
            } else if (val instanceof NavigationStart && (val as NavigationStart).url === this.componentRoute) {
                this.history = [];
            }
        });
        this.getTitle();
    }

    public getTitle(): void {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                if (((val as NavigationEnd).url && (val as NavigationEnd).url !== '/administration')) {
                    this.title = 'Administration';
                } else {
                    this.title = 'Bienvenue dans votre espace administration !';
                }
            }
        });
    }

    public goBack(): void {
        try {
            this.router.navigate([this.getPreviousPage()]);
        } catch (e) {
            throw e;
        }
    }

    public async logout(): Promise<void> {
        await this._auth.logoutSession();
        this._login.clearLocalSession();
        this.router.navigateByUrl('/');
    }

    private getPreviousPage(): string {
        this.history.pop();
        return this.history[this.history.length - 1] || this.componentRoute;
    }

    private addRouteToHistory(route: string): void {
        // On vérifie si la route est déjà présente dans l'historique de navigation
        if (this.history.includes(route)) {
            // Si la route est présente dans l'historique de navigation, on supprime les route suivantes
            for (let i = 0; i < this.history.length; i++) {
                if (this.history[i] === route) {
                    this.history.splice(i + 1, this.history.length - i);
                }
            }
        } else {
            // Sinon on ajoute la route à l'historique de navigation
            this.history.push(route);
        }
    }

}
